(function () {
  if (window.__AG_PB_INGREDIENTS_INIT__) return;
  window.__AG_PB_INGREDIENTS_INIT__ = true;

  var MOBILE_MAX = 740;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  /* Real slide wrappers as Shopify renders them (loop clones have their ids stripped). */
  var SLIDE_SELECTOR = '.shopify-block, [id^="shopify-block-"]';

  /* Includes loop clones — measurement and scroll positions need the full strip. */
  function getWrappers(root) {
    var track = root.querySelector('.js-ag-pb-ingredients-track');
    if (!track) return [];
    return Array.prototype.slice.call(
      track.querySelectorAll(
        ':scope > .shopify-block, :scope > [id^="shopify-block-"], :scope > [data-ag-swipe-clone]'
      )
    ).filter(function (el) {
      return el.querySelector('.ag-pb-ingredients-item');
    });
  }

  /* Loop controller per block root, so dots can map clones back to real slides. */
  var loops = new WeakMap();

  function toDotIndex(root, index) {
    var loop = loops.get(root);
    return loop ? loop.realIndex(index) : index;
  }

  function parseCssPx(value) {
    if (!value || value === 'none') return 0;
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  /** Pad track to content-max column (desktop align + mobile edges). */
  function syncAlignInset(root) {
    var section = root.closest('.shopify-section--ag-page-blocks') || root.closest('.ag-page-blocks');
    /* clientWidth, not innerWidth: it excludes the classic scrollbar, matching the
       coordinate space getBoundingClientRect() reports the edges in. */
    var viewport = document.documentElement.clientWidth;
    var desktop = !isMobile();
    var gutter = desktop ? 40 : 16;
    var rootRect = root.getBoundingClientRect();
    var left = null;
    var right = null;

    /*
      Merchant max-width: keep Liquid margin-inline (default 150 desktop).
      Do not overwrite with 0.
    */
    if (desktop && root.classList.contains('ag-pb-ingredients--max-desktop')) {
      return;
    }

    var measure = root.querySelector('.ag-pb-ingredients__max-measure');
    if (measure) {
      var rect = measure.getBoundingClientRect();
      if (rect.width > 0 && isFinite(rect.left) && isFinite(rect.right)) {
        if (rect.width >= viewport - 2) {
          left = gutter;
          right = viewport - gutter;
        } else {
          left = rect.left;
          right = rect.right;
        }
      }
    }

    if ((left == null || right == null) && section) {
      var sectionStyle = window.getComputedStyle(section);
      var maxRaw = desktop
        ? sectionStyle.getPropertyValue('--ag-page-blocks-content-max-desktop')
        : sectionStyle.getPropertyValue('--ag-page-blocks-content-max-mobile');
      var maxWidth = parseCssPx(maxRaw);

      if (maxWidth > 0 && maxWidth < viewport) {
        left = (viewport - maxWidth) / 2;
        right = left + maxWidth;
      } else {
        left = gutter;
        right = viewport - gutter;
      }
    }

    if (left == null || !isFinite(left)) {
      left = gutter;
      right = viewport - gutter;
    }

    var nextLeft = Math.max(0, Math.round(left - rootRect.left)) + 'px';
    var nextRight = Math.max(0, Math.round(rootRect.right - right)) + 'px';

    if (root.style.getPropertyValue('--ag-pb-ing-align-inset') !== nextLeft) {
      root.style.setProperty('--ag-pb-ing-align-inset', nextLeft);
    }
    if (root.style.getPropertyValue('--ag-pb-ing-pad-right') !== nextRight) {
      root.style.setProperty('--ag-pb-ing-pad-right', nextRight);
    }
  }

  function updateActiveDot(root, index) {
    var dotIndex = toDotIndex(root, index);
    var dots = root.querySelectorAll('.ag-pb-ingredients__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === dotIndex);
      dot.setAttribute('aria-current', i === dotIndex ? 'true' : 'false');
    });
  }

  /** Left-align slide to track content edge (respects scroll-padding / align inset). */
  function scrollToIndex(root, track, wrappers, index, velocityX, onDone) {
    var target = wrappers[index];
    if (!target || !track) return;

    var padLeft = parseFloat(window.getComputedStyle(track).scrollPaddingLeft);
    if (isNaN(padLeft)) {
      padLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
    }

    var trackRect = track.getBoundingClientRect();
    var itemRect = target.getBoundingClientRect();
    var offset = itemRect.left - trackRect.left - padLeft;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var left = track.scrollLeft + offset;

    /* Touch releases carry the flick speed into the settle so it coasts instead of
       running the browser's fixed smooth-scroll curve. Dots keep that curve. */
    if (typeof velocityX === 'number' && window.AgPbSwipe && window.AgPbSwipe.glide) {
      window.AgPbSwipe.glide(track, left, { velocityX: velocityX, onDone: onDone });
    } else {
      track.scrollTo({
        left: left,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      if (onDone) window.setTimeout(onDone, 450);
    }

    updateActiveDot(root, index);
  }

  function getClosestIndex(track, wrappers) {
    if (!track || wrappers.length === 0) return 0;

    var trackRect = track.getBoundingClientRect();
    var padLeft = parseFloat(window.getComputedStyle(track).scrollPaddingLeft);
    if (isNaN(padLeft)) {
      padLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
    }
    var alignX = trackRect.left + padLeft;
    var closest = 0;
    var closestDistance = Infinity;

    wrappers.forEach(function (wrapper, index) {
      var rect = wrapper.getBoundingClientRect();
      var distance = Math.abs(rect.left - alignX);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function syncActiveFromScroll(root, track, wrappers) {
    if (!track || wrappers.length === 0) return;
    updateActiveDot(root, getClosestIndex(track, wrappers));
  }

  /* Distance between two slide origins — one "advance" worth of travel. */
  function getStep(wrappers) {
    if (!wrappers || wrappers.length < 2) return 0;
    return Math.abs(
      wrappers[1].getBoundingClientRect().left - wrappers[0].getBoundingClientRect().left
    );
  }

  function buildDots(root, track, wrappers) {
    var dotsWrap = root.querySelector('.js-ag-pb-ingredients-dots');
    if (!dotsWrap) return;

    dotsWrap.innerHTML = '';

    if (!isMobile() || wrappers.length <= 1) {
      dotsWrap.hidden = true;
      dotsWrap.setAttribute('aria-hidden', 'true');
      return;
    }

    dotsWrap.hidden = false;
    dotsWrap.removeAttribute('aria-hidden');
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Ingredient slides');

    /* One dot per real slide — clones must not add dots of their own. */
    var loop = loops.get(root);
    var dotCount = loop ? loop.realCount : wrappers.length;

    for (var index = 0; index < dotCount; index++) {
      (function (dotIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ag-pb-ingredients__dot' + (dotIndex === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to ingredient ' + (dotIndex + 1));
        dot.setAttribute('aria-current', dotIndex === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          var current = getWrappers(root);
          var target = dotIndex;

          /* Looping: jump to whichever copy of that slide is nearest. */
          if (loop) {
            var here = getClosestIndex(track, current);
            var offset = loop.realIndex(dotIndex) - loop.realIndex(here);
            var half = loop.realCount / 2;
            if (offset > half) offset -= loop.realCount;
            if (offset < -half) offset += loop.realCount;
            target = Math.max(0, Math.min(here + offset, current.length - 1));
          }

          scrollToIndex(root, track, current, target, undefined, function () {
            if (loop) loop.normalize();
          });
        });
        dotsWrap.appendChild(dot);
      })(index);
    }
  }

  function initBlock(root) {
    if (root.dataset.agPbIngReady === 'true') return;

    var track = root.querySelector('.js-ag-pb-ingredients-track');

    if (!track || getWrappers(root).length === 0) return;

    root.dataset.agPbIngReady = 'true';

    /* Clone the set before anything measures, so dots and positions see the real strip.
       Desktop hides the clones in CSS — at 741+ this is a static centered row. */
    if (root.dataset.agPbLoop === 'true' && window.AgPbSwipe && window.AgPbSwipe.enableLoop) {
      var loop = window.AgPbSwipe.enableLoop(track, { slideSelector: SLIDE_SELECTOR });
      if (loop) {
        loops.set(root, loop);
        loop.reset();
      }
    }

    var wrappers = getWrappers(root);
    syncAlignInset(root);
    buildDots(root, track, wrappers);

    if (root.dataset.agPbAutoscroll === 'true' && window.AgPbSwipe && window.AgPbSwipe.autoScroll) {
      window.AgPbSwipe.autoScroll(track, { speed: parseFloat(root.dataset.agPbAutoscrollSpeed) });
    }

    /* Touch horizontal is JS-driven (CSS drops native h-scroll on coarse pointers).
       Settle on drag intent (distance/velocity) — nearest-slide alone would force a
       >50% swipe to advance, which reads as having to drag the full screen width. */
    if (window.AgPbSwipe) {
      var swipeStartIndex = 0;
      window.AgPbSwipe.bind(track, {
        enabled: isMobile,
        onStart: function () {
          swipeStartIndex = getClosestIndex(track, getWrappers(root));
        },
        onSettle: function (drag) {
          var current = getWrappers(root);
          scrollToIndex(
            root,
            track,
            current,
            window.AgPbSwipe.resolveIndex({
              startIndex: swipeStartIndex,
              count: current.length,
              deltaX: drag.deltaX,
              velocityX: drag.velocityX,
              step: getStep(current),
              fallbackIndex: getClosestIndex(track, current)
            }),
            drag.velocityX,
            /* Re-centre on the middle set once the glide lands, never mid-gesture. */
            function () {
              var activeLoop = loops.get(root);
              if (activeLoop) activeLoop.normalize();
            }
          );
        }
      });
    }

    requestAnimationFrame(function () {
      syncAlignInset(root);
      wrappers = getWrappers(root);
      buildDots(root, track, wrappers);
      if (isMobile()) syncActiveFromScroll(root, track, wrappers);
    });

    var scrollRaf = false;
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      if (scrollRaf) return;
      scrollRaf = true;
      requestAnimationFrame(function () {
        syncActiveFromScroll(root, track, getWrappers(root));
        scrollRaf = false;
      });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncAlignInset(root);
        wrappers = getWrappers(root);
        buildDots(root, track, wrappers);
        if (isMobile()) {
          syncActiveFromScroll(root, track, wrappers);
        } else {
          track.scrollLeft = 0;
        }
      }, 200);
    });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-ingredients').forEach(initBlock);
  }

  function resetAll() {
    document.querySelectorAll('.js-ag-pb-ingredients').forEach(function (root) {
      delete root.dataset.agPbIngReady;
    });
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', resetAll);
  document.addEventListener('shopify:block:select', resetAll);
})();
